<template>
    <div class="wrapper default">
        <div class="container">
            <div class="row">
                <div class="main-content col-12 col-md-7 col-lg-5 mx-auto">
                    <div class="account-box">
                        <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%">
                            <img style="position:absolute;top:50%;left:42%;z-index:100" src="/assets/img/loader/loader.svg" />
                        </div>
                        <router-link to="/" class="logo">
                            <img :src="baseInfo.LogoPicPath" :title="baseInfo.ShopName" :alt="baseInfo.ShopName" />
                        </router-link>
                        <div class="account-box-title text-right">ورود به سیستم</div>
                        <div class="account-box-content">
                            <ul style="color:red;font-size:12px;text-align:center;list-style-type:circle;margin-top:10px;">
                                <li v-for="error in errors.all()">{{ error }}</li>
                            </ul>
                            <form @submit.prevent="validateForm" class="form-account">

                                <div class="form-account-title"> شماره موبایل</div>
                                <div class="form-account-row">
                                    <label class="input-label"><i class="now-ui-icons users_single-02"></i></label>
                                    <input name="username" class="input-field" type="text" v-model="user.UserName" v-validate="{ required: true, regex: /^09\d{9}$/ }" data-vv-as="شماره موبایل"
                                           placeholder="شماره موبایل خود را وارد نمایید">
                                </div>
                                <div class="form-account-title">
                                    رمز عبور

                                    <router-link to="/forgetPassword" tag="a" class="btn-link-border form-account-link">
                                        رمز
                                        عبور خود را فراموش
                                        کرده ام
                                    </router-link>
                                </div>
                                <div class="form-account-row">
                                    <label class="input-label">
                                        <i class="now-ui-icons ui-1_lock-circle-open"></i>
                                    </label>
                                    <input name="password" class="input-field" type="password" v-model="user.Password" v-validate="{required: true , min:4 , max: 12}" data-vv-as="رمز عبور"
                                           placeholder="رمز عبور خود را وارد نمایید">
                                </div>
                                <div class="form-account-row form-account-submit">
                                    <div class="parent-btn">
                                        <button type="submit" class="dk-btn dk-btn-info">
                                            ورود
                                            <i class="fa fa-sign-in"></i>
                                        </button>
                                    </div>

                                </div>
                            </form>
                        </div>
                        <div class="account-box-footer">
                            <span>کاربر جدید هستید؟</span>

                            <router-link to="/register" tag="a" class="btn-link-border">
                                ثبت‌نام کنید
                            </router-link>
                            <div>
                                <router-link class="btn-redirect-page" to="/">بازگشت به صفحه اصلی</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <mini-footer></mini-footer>
    </div>

</template>

<script>
    import miniFooter from "../../sharedComponents/footerComponents/miniFooter.vue";
    import { httpPromise } from "../../../module/httpUtility.js";
    import { initialSite } from "../../../module/initialSite"
    export default {
        data() {
            return { user: {}, isShowSppiner: false}
        },
        components: {
            'mini-footer': miniFooter
        },
        methods: {
            validateForm() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.isShowSppiner = true;
                        httpPromise(this, '/v1/Identity/Account/Login', 'post', JSON.stringify(this.user),
                            response => {
                                localStorage.setItem('accessToken', response.data.Value.Token);
                                this.$store.commit('setUserFullName', response.data.Value.UserFullName);
                                var path = IsNullOrEmptyString(this.$route.query.returnUrl) ? '/' : this.$route.query.returnUrl;
                                this.isShowSppiner = false;
                                window.location.href  = path ;
                            },
                            response => {
                                toastr.error(response.data.Message);
                                this.isShowSppiner = false;
                            });
                    }
                });
            },
            resetForm() {
                this.user = {};
                this.$validator.reset();
                this.$validator.errors.clear();
            }
        },
        beforeMount: function () {
            createPageTitle('ورود به سیستم');
            initialSite(this);
        },
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        } ,
        beforeRouteEnter: (to, from, next) => {
            next(vm => {
                if (isUserLogined())
                    vm.$router.push('/');
            });
        }
    }
</script>

<style scoped>
    .btn-redirect-page {
        background-color: #fff8f8;
        border-bottom: 1px dashed #1ca2bd;
        margin-top: 10px;
        display: inline-block;
        border-radius: 5px;
        color: #1ca2bd;
        transition: all .3s;
        padding: 6px;
        font-size: 12px;
    }

        .btn-redirect-page:hover {
            transition: all .3s;
            color: #1ca2bd;
        }
</style>